import { Breakpoints } from '../../../utils/breakpoints';
import styled from 'styled-components';

export const BaseLayoutStyled = styled.div`
  max-width: ${Breakpoints.XXL};
  margin: 0 auto;
`;